import { config } from '@/apollo/config';
import { decodeBase64Id } from '@/helpers/decodeBase64Id';
import { Link } from '@/i18n/navigation';
import Image from 'next/image';
import styles from './popular-card.module.scss';
import DefaultProductPlaceholder from '@/assets/images/Yellow.png';
type Props = {
  title: string;
  image: any;
  id?: string;
  slug?: string;
};

const PopularCard = ({ id, slug, title, image }: Props) => {
  const href =
    id && slug
      ? `/category/${decodeBase64Id(id)}-${slug}`
      : '/catalog/category/smartphones';

  let imageUrl = null;
  try {
    if (image && config.publicApiUrl) {
      imageUrl = `${config.publicApiUrl}${image}`;
    }
  } catch (error) {
    console.error('Rasm yuklashda xatolik:', error);
  }

  return (
    <Link href={href} className={styles.popularCardWrapper}>
      <Image
        src={imageUrl || DefaultProductPlaceholder}
        alt={title || 'popular card'}
        width={80}
        height={80}
        style={{ objectFit: 'contain' }}
      />
      <h3>{title}</h3>
    </Link>
  );
};

export default PopularCard;
